import { useState, useEffect, useRef } from 'react';
import { getPreference, setPreference } from '../helpers/preferencesHelpers';

export function useExpandedFolders(user) {
  const userId = user?.id;
  const key = userId ? `expandedFolders_${userId}` : 'expandedFolders_guest';
  const isInitialMount = useRef(true);
  const [expandedFolders, setExpandedFolders] = useState(() => {
    const saved = getPreference(null, key, []);
    return new Set(saved);
  });

  useEffect(() => {
    // Skip save on initial mount (just loaded from storage)
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setPreference(null, key, [...expandedFolders]);
  }, [expandedFolders, key]);

  const toggleFolder = (id) => {
    setExpandedFolders(prev => {
      const copy = new Set(prev);
      copy.has(id) ? copy.delete(id) : copy.add(id);
      return copy;
    });
  };

  return { expandedFolders, setExpandedFolders, toggleFolder };
}
